import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { BeegoPage } from './beego.page';
import { TranslationModule } from '@app/app-translation.module';
import { BeegoMobilePage } from './mobile/beego.mobile.page';
import { BeegoDesktopPage } from './desktop/beego.desktop.page';
import { DirectivesModule } from '@shared-directives/directives.module';
import { HeaderComponentModule } from '@shared/gui/structural-components/header-component/header.component.module';
import { CalendarDesktopModule, CalendarMobileModule } from '@beego/ngx-calendar';
import { CalendarRecurringChangeComponentModule } from '@internal-components/calendar-components/calendar-recurring-change-component/calendar-recurring-change.component.module';
import { EventComponentModule } from '@internal-components/event-components/event-component/event.component.module';
import { EventDetailsComponentModule } from '@internal-components/event-components/event-details-component/event-details.component.module';
import { CreateBeegoAppointmentComponentModule } from '@internal-components/beego-appointment-components/create-beego-appointment-component/create-beego-appointment.component.module';
import { BeegoAppointmentDetailsComponentModule } from '@internal-components/beego-appointment-components/beego-appointment-details-component/event-details.component.module';
import { CalendarAddressFilterComponentModule } from '@internal-components/calendar-components/calendar-filter-components/calendar-address-filter-component/calendar-address-filter.component.module';
import { CalendarInputFilterComponentModule } from '@internal-components/calendar-components/calendar-filter-components/input-filter-component/input-filter.component.module';
import { CalendarSelectFilterComponentModule } from '@internal-components/calendar-components/calendar-filter-components/select-filter-component/select-filter.component.module';
import { TooltipModule } from '@make-lynxwork/ng2-tooltip-directive';
import { SegmentDesktopModule } from '@beego/ngx-segment';
import { TableDesktopModule } from '@beego/ngx-table';
import { PipesModule } from '../../../../shared/gui/pipes/pipes.module';
import { MobileBlockerComponentModule } from '@internal/gui/structural-components/mobile-blocker-component/mobile-blocker-component.module';

@NgModule({
	imports: [
		CommonModule,
		FormsModule,
		IonicModule,
		RouterModule.forChild([
			{
				path: '',
				component: BeegoPage,
			},
		]),
		TranslationModule,
		SegmentDesktopModule,
		TableDesktopModule,
		HeaderComponentModule,
		DirectivesModule,
		CalendarDesktopModule,
		CalendarMobileModule,
		CalendarRecurringChangeComponentModule,
		EventComponentModule,
		EventDetailsComponentModule,
		CreateBeegoAppointmentComponentModule,
		BeegoAppointmentDetailsComponentModule,
		CalendarAddressFilterComponentModule,
		CalendarInputFilterComponentModule,
		CalendarSelectFilterComponentModule,
		TooltipModule,
		PipesModule,
		MobileBlockerComponentModule,
	],
	declarations: [BeegoPage, BeegoMobilePage, BeegoDesktopPage],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class BeegoPageModule {}
